// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and
// compiles into the necessary css files
import style from "../scss/index.scss";

import "./lottie-player";

// Inject our components
require("./components/responsive-images.js");
require("./components/content-video-embeds.js");
require("./components/navigation.js");
require("./components/iframe-resize.js");
require("./components/homepage-slider.js");
require("./components/search.js");
require("./components/sidebar.js");
require("./components/accordion.js");
require("./components/people-bios.js");
require("./components/wysiwyg-styles.js");
require("./components/accordion-singlepage-element.js");
require("./components/jquery.fittext.js");
require("./components/single-page-banner-text.js");
require("./components/popup.js");
require("./components/single-page-articles.js");
require("./components/share-page.js");
require("./components/past-newsletters.js");
require("./components/signup-form-submission.js");
